import {AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {HelpersService} from '../../helpers.service';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {IAssignedPhotoCategory, IPhotoCategory} from 'src/app/visits/photo-categories/photo-category';


@Component({
    selector: 'app-assigned-photo-categories',
    templateUrl: './assigned-photo-categories.component.html',
    styleUrls: ['./assigned-photo-categories.component.scss'],
    standalone: false
})
export class AssignedPhotoCategoriesComponent implements AfterViewChecked {

  @Input() formGroup: FormGroup;
  @Input() selectablePhotoCategoryIds: number[];
  private _allPhotoCategories: IPhotoCategory[];

  get allPhotoCategories() : IPhotoCategory[]{
    return this._allPhotoCategories;
  }

  @Input()
  set allPhotoCategories(photoCategories) {
    this._allPhotoCategories = photoCategories;

    if (this._initialPhotoCategoriesIds) {
      this.assignedPhotoCategories = this.toPhotoCategoriesWithAssignedInfo(this._initialPhotoCategoriesIds, this.allPhotoCategories);
      if(this.selectablePhotoCategoryIds) {
        this.assignedPhotoCategories = this.assignedPhotoCategories
          .filter(photoCategory => this.selectablePhotoCategoryIds.includes(photoCategory.photoCategory.id));
      }
    }
  }

  _initialPhotoCategoriesIds: number[];
  private _photoCategoriesLoaded = true;
  @Output() onChange = new EventEmitter();

  @Input()
  set initialPhotoCategoryIds(photoCategoryIds: number[]) {

    if (photoCategoryIds === null) {
      photoCategoryIds = [];
    }

    this._initialPhotoCategoriesIds = photoCategoryIds;

    if (this.allPhotoCategories) {
      this.assignedPhotoCategories = this.toPhotoCategoriesWithAssignedInfo(this._initialPhotoCategoriesIds, this.allPhotoCategories);
      if(this.selectablePhotoCategoryIds) {
        this.assignedPhotoCategories = this.assignedPhotoCategories
          .filter(photoCategory => this.selectablePhotoCategoryIds.includes(photoCategory.photoCategory.id));
      }
    }

  }

  assignedPhotoCategories: IAssignedPhotoCategory [] = [];

  public get updatedPhotoCategoriesIds() {
    if (!this._photoCategoriesLoaded) {
      return this.initialPhotoCategoryIds;
    }

    const updatedPhotoCategoriesIds: number[] = [];
    this.assignedPhotoCategories.forEach(assignedPhotoCategory => {
      if (assignedPhotoCategory.assigned) {
        updatedPhotoCategoriesIds.push(assignedPhotoCategory.photoCategory.id);
      }
    });
    return updatedPhotoCategoriesIds;
  }

  constructor(
    public helpersService: HelpersService,
    public changeDetector: ChangeDetectorRef,
  ) {
  }

  ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }

  togglePhotoCategory(assignedPhotoCategory: IAssignedPhotoCategory) {
    assignedPhotoCategory.assigned = !assignedPhotoCategory.assigned;
    this.onChange.emit(this.updatedPhotoCategoriesIds);
    this.formGroup.markAsDirty();
  }

  get areAllSelected(): boolean {
    return this.assignedPhotoCategories.filter(item => !item.assigned).length === 0;
  }

  toggleSelectAll(change: MatCheckboxChange): void {
    this.assignedPhotoCategories.forEach(item => item.assigned = change.checked);
    this.onChange.emit(this.updatedPhotoCategoriesIds);
  }

  private toPhotoCategoriesWithAssignedInfo(assignedPhotoCategoriesIds: number[], allPhotoCategories: IPhotoCategory[]): IAssignedPhotoCategory[]{
    return  allPhotoCategories.map(photoCategory => {
      return {
        photoCategory: photoCategory,
        assigned: assignedPhotoCategoriesIds && assignedPhotoCategoriesIds.includes(photoCategory.id),
      };
    });
  }


}
